/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetUserWorkflowStepsResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'UserWorkflow',
        isRequired: true,
      },
    },
  }],
} as const;
